import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/file.vue
var o = {
	name: "DtIconFile",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--file"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "File",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M1.94.94A1.5 1.5 0 0 1 3 .5h4.25a.5.5 0 0 1 .354.146l2.75 2.75a.5.5 0 0 1 .146.354V10A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10V2c0-.398.158-.78.44-1.06ZM7.5 3.5V1.957L9.043 3.5H7.5ZM3 1.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V4.5H7a.5.5 0 0 1-.5-.5V1.5H3Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=file.js.map